// generated from 336 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const xMoneySpentInYDaysGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("x_money_spent_in_y_days"),
  comparison_key: z.enum([
    "5", // 136 (40.48%)
    "3", // 134 (39.88%)
    "1", // 66 (19.64%)
  ]),
  display_name: z.string(),
  // undefined: 210 (62.50%), defined 126 (37.50%)
  raw_value: z
    .object({
      num_days: z.int().min(1).max(30),
      num_occurrences: z.number().min(0),
    })
    .optional(),
  value: z.object({
    num_days: z.int().min(1).max(30),
    num_occurrences: z.number().min(0),
  }),
  varies_by_app_group: z.literal(false),
});
